import React, { Component } from "react";
import axios from "axios";
import ApiURL from "../../api/ApiURL";
import cogoToast from "cogo-toast";
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import PageTitle from "../home/PageTitle";
import AgGridComponent from "../common/AgGridComponent";
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from "../common/PaginationComponent";
import ConfirmModal from "../common/ConfirmModal";
import dayjs from "dayjs";
import {
  mapAgGridSortToApi,
  mapAgGridFilterToApi,
  LEAD_SORT_WHITELIST,
  LEAD_FILTER_WHITELIST,
} from "../../utils/agGridServerHelpers";

const formatEntryDate = (params) => {
  const value = params.value;
  if (value == null || value === "") {
    return "";
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : String(value);
};

class LeadActionCellRenderer extends Component {
  render() {
    const { data, onSelect } = this.props;
    if (!data) {
      return null;
    }
    return (
      <div className="text-center table-action-button" title="Select" style={{ cursor: "pointer" }} onClick={() => onSelect(data.EnquiryId)}>
        <i className="fa-solid fa-pen-to-square"></i>
      </div>
    );
  }
}

class LeadActiveCellRenderer extends Component {
  render() {
    const value = this.props.value;
    return (
      <div className="text-center">
        {value ? (
          <i className="fa-regular fa-square-check"></i>
        ) : (
          <i className="fa-regular fa-square-uncheck"></i>
        )}
      </div>
    );
  }
}

export default class SearchLead extends Component {
  //constructor lifecycle event
  constructor(props) {
    super(props);
    this.leadDataCancelToken = null;
    this.lookupDataLoaded = false;
    this.state = {
      showModal: false,
      showDeleteWarnModal: false,
      showConvertionWarnModal: false,
      convertStatus: 3,
      LeadData: [],
      isTableLoading: true,
      currentPage: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      totalRecords: 0,
      columnDefs: this.buildColumnDefs(),
      sortModel: [],
      filterModel: {},
      TCData: [],
      SPLData: [],
      LeadAssignData: [],
      OriginCityData: [],
      LeadSourceTypeData: [],
      LeadStatusData: [],
      UserId: 0,
      UserRole: "",
      RedirectToLogin: false,

      enquiryId: 0,
      leadNo: "",
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      message: "",
      travelDate: "",
      leadType: "",
      leadSourceId: 0,
      referrer: "",
      originCity: "",
      url: "",
      travelCircuitId: 0,
      specialistId: 0,
      ticketBooked: "",
      noOfGuests: "",
      hotelCategory: "",
      remarks: "",
      assignedId: 0,
      leadStatusId: "",
      isVoucherSent: false,
      isFinalPayReceived: false,
      isActive: true,
      disabledTC: false,
      disabledSpl: false,
      disabledLeadStatus: false,
    };
  }
  //componentDidMount lifecycle event
  componentDidMount() {
    window.scroll(0, 0);
    var userData = JSON.parse(LocalStorageHelper.getUser());
    if (userData !== null && userData.UserId > 0) {
      this.setState({
        UserId: userData.UserId,
        UserRole: userData.RoleName
      })
    }
    else {
      let winlocation = window.location.pathname;
      LocalStorageHelper.SetLastRedirectPath(winlocation);
      this.setState({ RedirectToLogin: true })
    }
    this.getAllLeadData(true);
  }
  componentWillUnmount() {
    if (this.leadDataCancelToken) {
      this.leadDataCancelToken.cancel("SearchLead unmounted");
    }
  }
  loadLookupData = () => {
    this.getAllLeadSourceTypes();
    this.getAllOriginCities();
    this.getAllTCData();
    this.getAllSPLData();
    this.getAllLeadStatus();
  }
  ensureLookupDataLoaded = () => {
    if (!this.lookupDataLoaded) {
      this.lookupDataLoaded = true;
      this.loadLookupData();
    }
  }
  //Data Reload (preserves active grid filters)
  handleReload = () => this.setState({ currentPage: 1 }, this.getAllLeadData);
  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.getAllLeadData);
  };
  handlePageSizeChange = (size) => {
    this.setState({ pageSize: size, currentPage: 1 }, this.getAllLeadData);
  };
  //Reset all input fields into the modal
  resetInputFields = () => {
    this.setState({
      showModal: false,
      showDeleteWarnModal: false,
      showConvertionWarnModal: false,
      enquiryId: 0,
      leadNo: "",
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      message: "",
      travelDate: "",
      leadType: "",
      leadSourceId: 0,
      referrer: "",
      originCity: "",
      url: "",
      travelCircuitId: 0,
      specialistId: 0,
      ticketBooked: "",
      noOfGuests: "",
      hotelCategory: "",
      remarks: "",
      assignedId: 0,
      leadStatusId: "",
      isVoucherSent: false,
      isFinalPayReceived: false,
      isActive: false,
      disabledTC: false,
      disabledSpl: false
    });
  }
  
  //Open modal
  openModal = () => {
    this.ensureLookupDataLoaded();
    this.setState({ showModal: true });
  };
  //Close modal
  closeModal = () => this.setState({ showModal: false, enquiryId: 0 });
  //Open Delete warning modal
  openDeleteWarnModal = () => this.setState({ showDeleteWarnModal: true });
  //Close Delete warning modal
  closeDeleteWarnModal = () => this.setState({ showDeleteWarnModal: false });
  //Open Convertion warning modal
  openConvertionWarnModal = () => this.setState({ showConvertionWarnModal: true });
  //Close Delete warning modal
  closeConvertionWarnModal = () => this.setState({ showConvertionWarnModal: false });

  //On Change Handler
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  // Maps ag-Grid sort/filter state to LeadRequestModel fields for uspGetLeadData.
  buildLeadDataParams = () => {
    const { currentPage, pageSize, sortModel, filterModel } = this.state;
    return {
      Skip: (currentPage - 1) * pageSize,
      Take: pageSize,
      ...mapAgGridSortToApi(sortModel, LEAD_SORT_WHITELIST),
      ...mapAgGridFilterToApi(filterModel, LEAD_FILTER_WHITELIST),
    };
  }
  //Get all Lead Data
  getAllLeadData = (loadLookupsAfter = false) => {
    if (this.leadDataCancelToken) {
      this.leadDataCancelToken.cancel("Superseded by new lead list request");
    }
    this.leadDataCancelToken = axios.CancelToken.source();
    const requestToken = this.leadDataCancelToken;

    this.setState({ isTableLoading: true });
    axios
      .post(ApiURL.GetAllLeadData, this.buildLeadDataParams(), {
        cancelToken: requestToken.token,
      })
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult || {};
          this.setState({
            LeadData: dataResult.Leads || [],
            totalRecords: dataResult.TotalRecords ?? 0,
          });
        } else if (respData.StatusCode === 404) {
          this.setState({
            LeadData: [],
            totalRecords: 0,
          });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return;
        }
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      })
      .finally(() => {
        if (this.leadDataCancelToken !== requestToken) {
          return;
        }
        this.setState({ isTableLoading: false });
        if (loadLookupsAfter && !this.lookupDataLoaded) {
          this.ensureLookupDataLoaded();
        }
      });
  }
  handleSortChange = (sortModel) => {
    this.setState({ sortModel, currentPage: 1 }, this.getAllLeadData);
  }
  handleFilterChange = (filterModel) => {
    this.setState({ filterModel, currentPage: 1 }, this.getAllLeadData);
  }
  buildColumnDefs = () => [
        {
          headerName: "Select",
          colId: "actions",
          sortable: false,
          filter: false,
          floatingFilter: false,
          resizable: false,
          width: 90,
          flex: 0,
          suppressSizeToFit: true,
          pinned: "left",
          cellClass: "text-center table-action-cell",
          headerClass: "text-center",
          cellRenderer: LeadActionCellRenderer,
          cellRendererParams: {
            onSelect: this.getDataItemById,
          },
        },
        {
          headerName: "Entry Date",
          field: "CreatedDate",
          width: 150,
          cellClass: "text-center",
          headerClass: "text-center",
          valueFormatter: formatEntryDate,
        },
        {
          headerName: "Customer Name",
          field: "FullName",
          width: 350,
          cellClass: "text-left",
        },
        {
          headerName: "Mobile",
          field: "Mobile",
          width: 200,
          cellClass: "text-center",
        },
        {
          headerName: "Email",
          field: "Email",
          minWidth: 250,
          cellClass: "text-left",
        },
        {
          headerName: "Travel Circuit",
          field: "TravelCircuitName",
          width: 250,
          cellClass: "text-center",
        },
        {
          headerName: "Lead Type",
          field: "LeadType",
          width: 200,
          cellClass: "text-center",
        },
        {
          headerName: "Status",
          field: "LeadStatusDescription",
          width: 200,
          cellClass: "text-center",
        },
        {
          headerName: "Assigned",
          field: "AssignedName",
          minWidth: 250,
          cellClass: "text-left",
        },
        {
          headerName: "Active",
          field: "IsActive",
          width: 90,
          sortable: false,
          filter: false,
          floatingFilter: false,
          cellClass: "text-center",
          cellRenderer: LeadActiveCellRenderer,
        },
      ]
  //Get all Lead Data ById
  getDataItemById = (keyData) => {
    var self = this;
    axios
      .get(ApiURL.GetLeadDataById(keyData))
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataRes = respData.DataResult;
          if (dataRes !== null) {
            var leadStatusState = dataRes.LeadStatusId == this.state.convertStatus;
            this.setState({
              enquiryId: dataRes.EnquiryId,
              leadNo: dataRes.EnquiryNo,
              firstName: dataRes.FirstName,
              lastName: dataRes.LastName,
              mobile: dataRes.Mobile,
              email: dataRes.Email,
              travelDate: dataRes.TravelDate,
              message: dataRes.Message,
              leadType: dataRes.LeadType,
              leadSourceId: dataRes.LeadSourceId,
              referrer: dataRes.Referrer,
              travelCircuitId: dataRes.TravelCircuitId,
              specialistId: dataRes.SpecialistId,
              url: dataRes.URL,
              originCity: dataRes.OriginCity,
              ticketBooked: dataRes.TicketBooked,
              noOfGuests: dataRes.NoOfGuests,
              hotelCategory: dataRes.HotelCategory,
              remarks: dataRes.Remarks,
              assignedId: dataRes.AssignedId,
              leadStatusId: dataRes.LeadStatusId,
              isVoucherSent: dataRes.IsVoucherSent,
              isFinalPayReceived: dataRes.IsFinalPayReceived,
              isActive: dataRes.IsActive,
              showModal: true,
              disabledTC: true,
              disabledSpl: true,
              disabledLeadStatus: leadStatusState,
            });
          }
        }
        else if (respData.StatusCode === 400) {
          cogoToast.error("Bad Request ! Please Try Again.", { position: "bottom-center" });
        }
        else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //Get all Travel Circuit data
  getAllTCData = () => {
    axios
      .get(ApiURL.GetAllTC)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          var travelCircuit = [{ TravelCircuitId: 0, TravelCircuitName: "--Select--" }];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              travelCircuit.push({
                TravelCircuitId: dataResult[i].TravelCircuitId,
                TravelCircuitName: dataResult[i].TravelCircuitName,
              });
            }
          }
          this.setState({ TCData: travelCircuit });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //Get all Specialist data
  getAllSPLData = () => {
    axios
      .get(ApiURL.GetAllSPL)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          var specialists = [{ SpecialistId: 0, SpecialistName: "--Select--" }];
          var leadAssignee = [{ SpecialistId: 0, SpecialistName: "--Select--" }];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              specialists.push({
                SpecialistId: dataResult[i].SpecialistId,
                SpecialistName: dataResult[i].SpecialistName,
              });

              leadAssignee.push({
                SpecialistId: dataResult[i].SpecialistId,
                SpecialistName: dataResult[i].SpecialistName,
              })
            }
          }
          this.setState({
            SPLData: specialists,
            LeadAssignData: leadAssignee
          });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", {
            position: "bottom-center",
          });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", {
          position: "bottom-center",
        });
      });
  }
  //Get all Origin Cities
  getAllOriginCities = () => {
    axios
      .get(ApiURL.GetAllOriginCities)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          var originCities = [{ CityId: 0, CityName: "--Select--" }];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              originCities.push({
                CityId: dataResult[i].CityId,
                CityName: dataResult[i].CityName,
              });
            }
          }
          this.setState({ OriginCityData: originCities });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //Get all Origin Cities
  getAllLeadSourceTypes = () => {
    axios
      .get(ApiURL.GetLeadSrcTypes)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          var leadSourceTypes = [{ LeadSourceId: 0, LeadSource: "--Select--" }];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              leadSourceTypes.push({
                LeadSourceId: dataResult[i].LeadSourceId,
                LeadSource: dataResult[i].LeadSource,
              });
            }
          }
          this.setState({ LeadSourceTypeData: leadSourceTypes });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //Get all Origin Cities
  getAllLeadStatus = () => {
    axios
      .get(ApiURL.GetLeadStatus)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          var leadStatus = [{ LeadStatusId: 0, LeadStatusDescription: "--Select--" }];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              leadStatus.push({
                LeadStatusId: dataResult[i].LeadStatusId,
                LeadStatusDescription: dataResult[i].LeadStatusDescription,
              });
            }
          }
          this.setState({ LeadStatusData: leadStatus });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //Add new Lead
  addNewLead = () => {
    this.resetInputFields()
    this.openModal()
  }
  //Handle submit
  handleSubmit = (e) => {
    var currentLead = this.state.LeadData.find(a => a.EnquiryId == this.state.enquiryId);
    if (currentLead !== null && this.state.leadStatusId == currentLead?.LeadStatusId) {
      this.openConvertionWarnModal();
    }
    else {
      this.saveLeadData(e);
    }
  }
  //Save new/existing Lead Data
  saveLeadData = (e) => {
    e.preventDefault();
    var userData = JSON.parse(LocalStorageHelper.getUser());
    if (userData !== null && userData.UserId > 0) {
      let finYearId = userData.FinYearId;
      let param = {
        EnquiryId: this.state.enquiryId,
        LeadNo: this.state.leadNo,
        FirstName: this.state.firstName,
        LastName: this.state.lastName,
        Mobile: this.state.mobile,
        Email: this.state.email,
        TravelDate: this.state.travelDate,
        Message: this.state.message,
        LeadType: this.state.leadType,
        LeadSourceId: this.state.leadSourceId,
        Referrer: this.state.referrer,
        TravelCircuitId: this.state.travelCircuitId,
        SpecialistId: this.state.specialistId,
        URL: this.state.url,
        OriginCity: this.state.originCity,
        TicketBooked: this.state.ticketBooked,
        NoOfGuests: this.state.noOfGuests,
        HotelCategory: this.state.hotelCategory,
        Remarks: this.state.remarks,
        AssignedId: this.state.assignedId,
        LeadStatusId: this.state.leadStatusId,
        IsVoucherSent: this.state.isVoucherSent,
        IsFinalPayReceived: this.state.isFinalPayReceived,
        IsActive: this.state.isActive,
        UserId: this.state.UserId,
      };
      axios
        .post(ApiURL.SaveLeadData, param)
        .then((response) => {
          let respData = response.data;
          if (respData.StatusCode === 200) {
            cogoToast.success(respData.Message, { position: "bottom-center" });
            this.resetInputFields();
            this.getAllLeadData();
          }
          else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
            cogoToast.error(respData.DataResult, { position: "bottom-center" });
          }
          else if (respData.StatusCode === 500) {
            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
          }
        })
        .catch((error) => {
          cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
        });
    }
  }
  //Delete existing Lead Data
  handleDelete = () => {
    let param = {
      enquiryId: this.state.enquiryId,
    };
    axios
      .post(ApiURL.DeleteLeadData, param)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          cogoToast.success(respData.Message, { position: "bottom-center" });
          this.resetInputFields();
          this.getAllLeadData();
        }
        else if (respData.StatusCode === 400) {
          cogoToast.warn(respData.Message, { position: "bottom-center" });
        }
        else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //render lifecycle event.
  render() {
    var self = this;
    const {
      showModal,
      showDeleteWarnModal,
      showConvertionWarnModal,
      LeadData,
      currentPage,
      pageSize,
      totalRecords,
      TCData,
      columnDefs,
      SPLData,
      LeadAssignData,
      OriginCityData,
      LeadSourceTypeData,
      LeadStatusData,
      enquiryId,
      travelCircuitId,
      specialistId,
      leadSourceId,
      assignedId,
      isActive
    } = self.state;
    return (
      <>
        {/* ------Start main content ------- */}
        <div className="master-page">
        <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
          <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
            <div className="col-md-7 justify-content-start">
              <PageTitle Title="Manage Search Lead" />
            </div>
            <div className="col-md-5 text-right">
              <button className="btn btn-outline-primary btn-sm px-3 mx-1" title="Refresh" onClick={this.handleReload}>
                <i className="fa-solid fa-arrows-rotate"></i> Refresh
              </button>
              <button className="btn btn-outline-primary btn-sm px-3 mx-1" title="Add" onClick={this.addNewLead}>
                <i className="fa-solid fa-plus"></i> Add
              </button>
            </div>
          </div>
        </div>
        <div className="master-page__body">
              <PaginationComponent
                currentPage={currentPage}
                totalPages={Math.ceil(totalRecords / pageSize) || 1}
                pageSize={pageSize}
                totalRecords={totalRecords}
                pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
                onPageChange={this.handlePageChange}
                onPageSizeChange={this.handlePageSizeChange}
              />
              <div className="master-page__grid">
                <AgGridComponent
                  columnDefs={columnDefs}
                  rowData={LeadData}
                  isLoading={this.state.isTableLoading}
                  onSortChange={this.handleSortChange}
                  onFilterChange={this.handleFilterChange}
                  fillHeight
                />
              </div>
        </div>
        </div>

        {/* <!----------------- modal section----------------> */}
        <div
          className={
            showModal === true ? "modal show-modal  modalWrapper" : "modal"
          }
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title ">
                  {enquiryId <= 0 ? `Add Search Lead` : `Update Search Lead`}
                </h1>
                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
              </div>

              <div className="modal-body">
                <div className="row  mx-3 mb-3">
                  <div className="col-sm-3">
                    <label className="form-label">Lead No.</label>
                    <input type="text" name="leadNo" className="form-control-sm border border-primary w-100" value={this.state.leadNo} onChange={this.handleChange} disabled />
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">First Name <span className='text-danger'>*</span></label>
                    <input type="text" name="firstName" className="form-control-sm border border-primary w-100" value={this.state.firstName} onChange={this.handleChange} />
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Last Name <span className='text-danger'>*</span></label>
                    <input type="text" name="lastName" className="form-control-sm border border-primary w-100" value={this.state.lastName} onChange={this.handleChange} />
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Mobile <span className='text-danger'>*</span></label>
                    <input type="text" name="mobile" className="form-control-sm border border-primary w-100" value={this.state.mobile} onChange={this.handleChange} />
                  </div>
                </div>
                <div className="row  mx-3 mb-3">
                  <div className="col-sm-6">
                    <label className="form-label">Email <span className='text-danger'>*</span></label>
                    <input type="text" name="email" className="form-control-sm border border-primary w-100" value={this.state.email} onChange={this.handleChange} />
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Travel Date</label>
                    <input type="date" id="travelDate" name="travelDate" className="form-control-sm border border-primary w-100" placeholder="dd-mm-yyyy" value={this.state.travelDate} onChange={this.handleChange} />
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Lead Type</label>
                    <input type="text" name="leadType" className="form-control-sm border border-primary w-100" value={this.state.leadType} onChange={this.handleChange} disabled />
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-3">
                    <label className="form-label">Lead Source <span className='text-danger'>*</span></label>
                    <select className="form-control-sm border border-primary form-select w-100" name="leadSourceId" value={this.state.leadSourceId} onChange={this.handleChange}>
                      {LeadSourceTypeData.map((item, index) => (
                        <option key={index} value={item.LeadSourceId}>{item.LeadSource}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Origin City</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="originCity"
                      value={this.state.originCity}
                      onChange={this.handleChange}
                    >
                      {OriginCityData.map((item, index) => (
                        <option key={index} value={item.CityName}>{item.CityName}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Travel Circuit</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="travelCircuitId"
                      value={this.state.travelCircuitId}
                      onChange={this.handleChange}
                      disabled
                    >
                      {TCData.map((item, index) => (
                        <option key={index} value={item.TravelCircuitId}>{item.TravelCircuitName}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Specialist</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="specialistId"
                      value={this.state.specialistId}
                      onChange={this.handleChange}
                      disabled
                    >
                      {SPLData.map((item, index) => (
                        <option key={index} value={item.SpecialistId}>{item.SpecialistName}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-12">
                    <label className="form-label">Message</label>
                    <textarea
                      style={{ height: '80px' }}
                      className="form-control-sm border border-primary w-100"
                      name="message"
                      value={this.state.message}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-12">
                    <label className="form-label">Referrer</label>
                    <input
                      type="text"
                      className="form-control-sm border border-primary w-100"
                      name="referrer"
                      value={this.state.referrer}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-12">
                    <label className="form-label">URL <span className='text-danger'>*</span></label>
                    <input
                      className="form-control-sm border border-primary w-100"
                      name="url"
                      value={this.state.url}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-3">
                    <label className="form-label">Ticket Booked</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="ticketBooked"
                      value={this.state.ticketBooked}
                      onChange={this.handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                      <option value="Will do soon">Will do soon</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">No. Of Guests</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="noOfGuests"
                      value={this.state.noOfGuests}
                      onChange={this.handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="L7">7</option>
                      <option value="8">8</option>
                      <option value="More than 8">More than 8</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Hotel Category</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="hotelCategory"
                      value={this.state.hotelCategory}
                      onChange={this.handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="5 Star">5 Star</option>
                      <option value="4 Star">4 Star</option>
                      <option value="3 Star">3 Star</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Lead Assigned <span className='text-danger'>*</span></label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="assignedId"
                      value={this.state.assignedId}
                      onChange={this.handleChange}
                    >
                      {LeadAssignData.map((item, index) => (
                        <option key={index} value={item.SpecialistId}>
                          {item.SpecialistName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-12">
                    <label className="form-label">Remarks</label>
                    <input
                      type="text"
                      className="form-control-sm border border-primary w-100"
                      name="remarks"
                      value={this.state.remarks}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row mx-3 my-3">
                  <div className="col-sm-3">
                    <label className="form-label">Lead Status <span className='text-danger'>*</span></label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="leadStatusId"
                      value={this.state.leadStatusId}
                      onChange={this.handleChange}
                    >
                      {LeadStatusData.map((item, index) => (
                        <option key={index} value={item.LeadStatusId}>{item.LeadStatusDescription}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Is Voucher Sent?</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="isVoucherSent"
                      value={this.state.isVoucherSent}
                      onChange={this.handleChange}
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label className="form-label">Is Final Payment Received?</label>
                    <select
                      className="form-control-sm border border-primary form-select w-100"
                      name="isFinalPayReceived"
                      value={this.state.isFinalPayReceived}
                      onChange={this.handleChange}
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer my-3">
                <button
                  type="submit"
                  className="btn btn-success button-box-shadow"
                  disabled={this.state.disabledLeadStatus}
                  onClick={this.handleSubmit}>
                  <i className="fa-solid fa-circle-check"></i> Save
                </button>
                {
                  this.state.UserRole === "admin" &&
                  <button
                    type="button"
                    disabled={this.state.disabledLeadStatus}
                    className={`btn btn-danger button-box-shadow curser-pointer ${enquiryId > 0 ? "" : "disabled"}`}
                    onClick={() => { enquiryId > 0 && this.openDeleteWarnModal(); }}>
                    <i className="fa-solid fa-trash-can"></i> Delete
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-secondary button-box-shadow"
                  data-bs-dismiss="modal"
                  onClick={this.closeModal}
                >
                  <i className="fa-solid fa-circle-xmark"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <!------Delete Warning Modal--------> */}
        <ConfirmModal
          show={showDeleteWarnModal}
          title="Confirm Delete"
          message="Are you sure to delete this item?"
          confirmText="Delete"
          cancelText="Cancel"
          onConfirm={this.handleDelete}
          onCancel={this.closeDeleteWarnModal}
        />

        {/* <!------Convertion Warning Modal--------> */}
        <ConfirmModal
          show={showConvertionWarnModal}
          title="Confirm Lead Convertion"
          message="Are you sure you want to convert this lead into a booking?"
          confirmText="Convert"
          cancelText="Cancel"
          onConfirm={this.saveLeadData}
          onCancel={this.closeConvertionWarnModal}
        />

      </>
    );
  }
}
